import { Box } from "@mui/material";
import PendingChatStats from "src/components/pages/dashboard/PendingChatStats";
import DashboardUsers from "src/components/pages/dashboard/DashboardUsers";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import useStyles from "./Styles";

const SecondLayer = () => {
  const { classes } = useStyles();
  const { panelType } = useActiveUserDetail();
  const showComp = panelType !== "AGENT";

  return (
    <Box className={classes.rootContainer}>
      {showComp && (
        <Box className={classes.flexItem50}>
          <DashboardUsers />
        </Box>
      )}
      <Box className={showComp ? classes.flexItem50 : classes.flexItemFull}>
        <PendingChatStats />
      </Box>
    </Box>
  );
};

export default SecondLayer;
